import queryString from 'query-string';
import { apiGET } from './api';

export const getUserLogs = (userId) => {
  const query = queryString.stringify(
    {
      user_id: userId,
    },
    {
      skipNull: true,
    }
  );

  return apiGET(`/crud-actions?${query}`);
};

export const getRescueLogs = (rescueId) => {
  const query = queryString.stringify(
    {
      rescue_id: rescueId,
    },
    {
      skipNull: true,
    }
  );

  return apiGET(`/crud-actions?${query}`);
};

export const getPickupSpecLogs = (pickupSpecId) => {
  const query = queryString.stringify(
    {
      pickup_spec_id: pickupSpecId,
    },
    {
      skipNull: true,
    }
  );

  return apiGET(`/crud-actions?${query}`);
};

export const getDonationLogs = (donationId) => {
  const query = queryString.stringify(
    {
      item_id: donationId,
    },
    {
      skipNull: true,
    }
  );

  return apiGET(`/crud-actions?${query}`);
};

export const getFoodDonorLogs = (foodDonorId) => {
  const query = queryString.stringify(
    {
      item_id: foodDonorId,
      action_type: ['DONOR_CREATED', 'DONOR_MODIFIED', 'DONOR_DELETED'],
    },
    {
      skipNull: true,
    }
  );

  return apiGET(`/crud-actions?${query}`);
};

export const getReceivingAgencyLogs = (receiverId) => {
  const query = queryString.stringify(
    {
      item_id: receiverId,
      action_type: ['RECEIVING_AGENCY_CREATED', 'RECEIVING_AGENCY_MODIFIED'],
    },
    {
      skipNull: true,
    }
  );

  return apiGET(`/crud-actions?${query}`);
};
